/* Motorised price grids for wood 70 mm, bamboo 50 mm and bamboo 65 mm.
   Read out of the Anwis 2026 price list on 11 August 2026.

   SOURCE PAGES (PDF numbering): wood 70 mm 98-99, bamboo 50 mm 113-115,
   bamboo 65 mm 120-121. All three cross-reference the SAME motor and control
   list on printed pages 90-91, so assets/naru-motors.js needs no change for
   them - only the price carcass underneath differs.

   VERIFIED against the worked example printed beside each matrix:
     wood 70    2250 x 3820, 19_NL     -> 969   (list prints 969 + 195,8 + 136,7)
     bamboo 50  1950 x 2400, AN 83_50  -> 360   (list prints 360 + 308 + 41,8)
     bamboo 65  1950 x 2400, AN 83_65  -> 401   (list prints 401 + 308 + 112,2)

   AND against a checksum. These grids were typed in by hand from a generated
   listing, 2642 numbers of them, and a single wrong digit is a wrong price that
   nothing downstream would catch. So the totals and the count of priced cells
   are recorded below and checked at load. If a check fails the grid is NOT
   attached: the motor option simply does not appear for that product, and the
   console says which grid is wrong. Silence is the pass condition.

   ALIGNMENT. A motorised grid does not start where the hand-operated one does:
   the motorised minimum width is 800 mm everywhere, while the C+T grids begin
   at 500 or 600 mm, and wood 70 and bamboo 65 start their motorised drop at
   600 mm rather than 300. Rather than hard-code the offset, attach() reads each
   family's own w0 and h0 and pads with zero columns and zero rows until it
   lines up. Zero reads as "not manufactured" to the configurator, which is
   exactly right below the motorised minimum.

   RAGGED ON PURPOSE. The tall-and-wide corner of every grid is blank in the
   printed table and blank here. Those sizes are not made.

   TWO FAMILIES PER BAMBOO. Bamboo 50 and bamboo 65 each have a plain family and
   an XL one that reaches further in width on selected NATURAL colours. They
   share one grid; only mtLim differs.
*/
(function () {
  var STEP = 0.1;

  function check(name, grid, sum, cells) {
    var s = 0, n = 0, r, c, v;
    for (r = 0; r < grid.length; r++) {
      for (c = 0; c < grid[r].length; c++) {
        v = grid[r][c];
        s += v;
        if (v) { n++; }
      }
    }
    if (s === sum && n === cells) { return true; }
    if (window.console && console.error) {
      console.error('naru: motorised grid ' + name + ' failed its checksum (sum ' +
        s + ' vs ' + sum + ', priced cells ' + n + ' vs ' + cells +
        '). The grid has been damaged in transcription and is NOT being used.');
    }
    return false;
  }

  function attach(X, grid, gw0, gh0, lim) {
    if (!X || !X.FAM || !grid) { return; }
    var padW = Math.round((gw0 - X.FAM.w0) / STEP);
    var padH = Math.round((gh0 - X.FAM.h0) / STEP);
    if (padW < 0 || padH < 0) { return; }
    var width = padW + grid[0].length, out = [], r, c, row;
    for (r = 0; r < padH; r++) {
      row = [];
      for (c = 0; c < width; c++) { row.push(0); }
      out.push(row);
    }
    for (r = 0; r < grid.length; r++) {
      row = [];
      for (c = 0; c < padW; c++) { row.push(0); }
      out.push(row.concat(grid[r]));
    }
    X.MT = [out];
    X.mtLim = lim.slice();
  }

  /* wood 70 mm - widths 0,8-2,9, heights 0,6-4,0, one price group (NATURAL) */
  var W70 = [
  [121,129,135,142,152,160,170,189,197,206,225,233,244,252,271,279,290,299,308,318,339,347],
  [127,135,142,153,161,174,183,202,209,220,241,251,259,269,290,300,310,320,327,340,360,369],
  [133,141,152,161,174,184,192,211,224,233,256,266,275,285,309,320,328,341,350,359,385,395],
  [139,150,160,174,184,194,204,225,235,249,271,282,293,302,326,340,350,359,370,383,407,419],
  [149,160,174,185,197,208,220,246,256,268,291,303,318,326,352,364,377,390,402,414,439,453],
  [157,169,183,194,207,219,232,256,269,282,308,321,331,346,370,385,398,409,422,434,463,477],
  [165,177,190,203,217,228,246,269,282,295,323,337,348,361,390,405,418,430,445,459,485,498],
  [173,185,198,211,225,241,254,282,295,310,339,351,364,381,408,422,436,452,465,480,508,525],
  [181,195,209,224,241,256,271,299,314,327,358,374,389,405,433,450,465,480,495,510,543,558],
  [188,203,219,233,251,266,283,311,326,344,374,390,406,421,453,471,483,499,519,534,564,582],
  [194,210,226,246,260,276,294,324,341,357,389,406,422,439,473,487,503,524,539,555,592,607],
  [202,219,234,253,270,286,304,339,353,370,405,421,439,458,490,505,527,543,559,578,612,629],
  [208,225,246,263,279,299,319,348,365,385,420,436,456,475,506,528,545,561,582,599,634,655],
  [219,235,256,274,294,313,331,365,386,405,439,460,478,497,534,551,572,594,611,630,669,686],
  [224,246,265,284,303,324,345,380,399,419,456,476,495,517,551,572,594,612,631,654,692,710],
  [232,253,272,293,314,333,356,391,410,432,473,492,514,533,570,593,612,632,655,675,716,734],
  [240,260,282,302,324,345,365,405,425,447,484,505,530,549,592,611,631,655,676,697,739,759],
  [250,271,293,318,339,359,383,421,445,466,505,531,550,573,615,635,661,682,705,729,770,796],
  [256,278,301,324,347,369,395,433,458,480,524,545,568,594,632,658,681,704,729,750,796,817],
  [263,286,310,331,357,382,406,447,472,494,537,560,586,610,654,676,701,725,749,771,817,841],
  [270,294,320,344,365,391,418,459,483,506,551,575,604,626,671,695,722,746,770,797,841,866],
  [276,301,326,352,377,403,427,473,496,524,568,594,618,644,688,716,743,767,794,818,864,889],
  [286,313,340,363,391,418,446,487,517,542,590,615,640,669,716,743,768,797,822,847,897,924],
  [293,321,347,374,402,427,458,499,530,555,605,630,659,684,733,761,789,816,842,872,920,947],
  [300,326,356,383,410,437,471,515,542,569,618,648,675,704,750,779,807,836,866,893,943,971],
  [308,337,363,394,421,450,480,528,555,585,632,664,693,722,770,800,829,858,886,916,967,995],
  [319,346,376,406,433,464,495,544,573,605,657,684,716,746,798,825,856,886,917,947,998,1029],
  [324,353,385,414,445,475,505,556,589,617,671,701,731,762,812,845,876,905,937,969,1022,1052],
  [329,360,394,422,456,484,521,569,600,630,684,719,748,779,834,866,897,930,959,992,1044,1077],
  [340,369,402,432,465,495,531,582,614,645,701,732,766,798,850,884,917,949,979,1012,1071,1100],
  [345,377,409,443,475,505,542,595,626,661,719,749,783,812,870,901,936,970,1001,1034,1093,1125],
  [353,389,421,455,487,523,556,612,645,677,737,770,805,839,896,931,962,998,1032,0,0,0],
  [360,397,428,464,497,533,568,624,659,693,751,787,821,857,912,950,982,1019,1053,0,0,0],
  [368,403,437,474,506,543,581,634,672,706,768,803,837,874,933,969,1006,1037,0,0,0,0],
  [376,410,447,482,521,552,593,651,684,722,783,819,856,892,951,987,1023,0,0,0,0,0]
  ];

  /* bamboo 50 mm - widths 0,8-3,6, heights 0,3-4,0, one price group.
     Printed as two blocks side by side; joined here. */
  var B50 = [
  [69,72,74,78,82,84,89,99,105,108,120,123,127,130,141,147,150,153,158,161,174,177,181,184,187,190,194,197,201],
  [72,75,79,83,88,92,97,109,114,117,129,133,136,140,153,158,161,164,167,171,190,194,197,201,204,208,211,214,217],
  [78,82,85,90,97,100,107,120,123,129,140,146,150,154,170,175,181,186,191,197,209,214,220,225,231,236,241,248,253],
  [82,85,92,97,103,108,115,126,132,136,150,154,160,167,183,188,192,197,202,207,223,227,232,236,240,246,250,254,259],
  [85,92,97,103,109,116,121,134,139,146,159,166,173,177,192,198,204,210,215,221,237,242,249,254,260,265,271,276,282],
  [90,97,103,109,117,122,127,140,148,153,170,176,183,189,204,210,217,225,233,240,254,262,270,277,285,294,301,309,316],
  [96,100,109,116,122,127,134,149,154,161,179,186,192,198,216,223,228,234,239,246,266,272,277,283,288,295,300,306,311],
  [100,109,117,123,130,136,142,159,167,175,191,198,206,215,231,240,247,252,258,263,286,293,298,303,309,314,320,325,331],
  [107,115,121,129,135,141,150,169,176,184,202,208,217,224,244,252,259,265,272,278,301,308,314,321,327,335,341,348,354],
  [112,120,126,134,140,149,158,176,185,191,210,219,226,234,254,263,271,278,286,295,313,321,328,337,345,352,360,368,375],
  [116,123,132,139,148,154,166,184,191,199,220,227,235,247,266,274,283,293,301,310,329,339,348,357,365,374,384,393,401],
  [121,130,138,147,154,166,175,194,203,210,232,244,252,260,282,291,300,309,318,326,349,358,366,375,385,394,402,411,420],
  [125,134,141,152,161,173,183,202,210,222,244,252,261,271,293,302,313,324,336,347,363,374,386,397,408,419,431,441,452],
  [129,138,148,158,169,179,189,209,220,228,252,261,271,282,303,314,325,337,348,359,377,389,400,411,422,434,445,456,466],
  [134,142,153,165,175,185,195,217,226,240,261,271,283,293,318,326,339,351,363,375,391,403,415,428,440,452,464,477,489],
  [138,148,159,170,183,191,203,225,234,249,271,282,293,303,326,340,350,360,370,381,408,418,428,438,448,458,469,478,488],
  [142,154,166,177,189,199,211,234,249,259,283,295,308,320,344,353,365,377,390,402,426,438,450,462,475,487,499,511,524],
  [148,159,173,184,195,207,220,244,256,268,293,303,319,327,353,365,380,393,406,419,440,453,466,481,494,507,521,534,547],
  [152,165,177,189,202,215,226,252,265,275,302,314,326,341,364,380,391,403,415,428,456,469,481,493,505,518,530,542,553],
  [157,170,184,194,207,220,233,259,271,284,311,324,339,350,377,391,405,418,432,445,472,485,498,511,525,538,551,565,578],
  [161,176,189,203,216,227,244,270,283,295,324,340,351,364,394,407,420,434,447,460,488,501,515,528,542,555,569,582,595],
  [167,183,194,208,222,234,251,276,291,303,333,348,360,376,405,419,432,444,456,469,506,519,531,543,555,568,580,592,605],
  [173,186,199,215,227,244,257,285,300,314,344,358,371,387,415,430,446,462,480,496,520,536,552,570,586,604,620,636,654],
  [176,190,206,220,233,250,265,293,308,323,352,365,383,398,426,443,458,474,489,505,534,549,565,581,596,612,627,643,659],
  [181,195,209,225,241,256,271,301,318,329,361,377,394,408,437,455,472,488,505,522,546,563,580,596,613,630,647,663,680],
  [186,202,217,232,250,265,282,311,326,344,376,391,407,422,455,473,485,497,509,522,569,581,593,606,618,630,642,655,667],
  [190,207,223,240,254,271,288,320,337,351,385,402,418,433,465,482,497,513,528,544,581,596,612,627,643,659,674,689,0],
  [195,210,227,246,261,276,295,326,344,359,395,410,426,445,477,494,510,527,544,561,595,612,629,645,662,679,696,0,0],
  [199,216,232,251,268,284,302,333,351,368,403,420,437,456,487,505,525,545,565,585,610,630,650,670,689,710,0,0,0],
  [206,223,241,257,275,293,311,346,361,381,415,433,452,472,501,524,542,560,577,595,632,650,668,685,704,0,0,0,0],
  [209,226,247,263,282,300,320,352,370,389,425,445,463,480,517,534,551,570,587,606,643,661,679,697,0,0,0,0,0],
  [215,232,252,269,288,304,325,359,381,399,434,455,474,492,528,547,564,581,597,614,660,676,694,0,0,0,0,0,0],
  [219,235,256,274,294,313,331,368,387,407,445,464,482,500,540,558,578,599,621,642,671,693,713,0,0,0,0,0,0],
  [223,242,261,279,300,321,341,376,397,415,455,475,493,514,550,569,592,615,638,662,686,710,733,0,0,0,0,0,0],
  [227,250,269,288,309,327,350,387,407,426,466,485,505,528,564,589,608,625,643,0,0,0,0,0,0,0,0,0,0],
  [232,253,274,294,314,333,357,395,415,434,476,496,519,539,575,598,619,638,659,0,0,0,0,0,0,0,0,0,0],
  [235,259,278,300,322,343,363,403,422,445,484,505,530,548,592,610,630,650,0,0,0,0,0,0,0,0,0,0,0],
  [242,263,284,304,326,348,370,409,430,453,494,519,539,559,600,621,644,0,0,0,0,0,0,0,0,0,0,0,0]
  ];

  /* bamboo 65 mm - widths 0,8-2,9, heights 0,6-4,0, one price group */
  var B65 = [
  [142,159,161,173,176,177,178,180,220,221,224,225,227,233,266,267,268,269,274,274,306,307],
  [145,164,165,176,179,181,182,184,228,229,231,233,234,239,274,274,275,276,280,282,314,315],
  [149,167,168,180,182,184,185,187,238,239,241,242,244,250,285,285,286,287,291,293,324,325],
  [152,171,172,184,186,188,189,191,245,246,248,250,252,258,291,292,293,294,299,299,331,332],
  [152,171,172,187,190,191,194,195,252,254,255,257,259,265,299,299,300,301,306,307,338,339],
  [161,179,180,199,202,203,205,207,271,272,274,276,277,284,317,317,318,319,324,325,354,354],
  [165,182,184,203,206,207,208,210,278,280,282,284,285,291,323,325,325,326,331,331,361,362],
  [165,182,184,203,206,207,209,211,282,284,285,287,289,295,328,328,329,330,334,335,365,365],
  [169,186,187,209,212,214,215,217,293,294,296,298,299,305,338,338,339,341,345,347,376,377],
  [173,190,191,213,216,218,219,221,299,301,302,304,306,312,345,346,347,348,353,353,383,383],
  [181,198,200,221,225,227,228,230,319,320,322,324,325,331,362,363,364,365,371,371,397,398],
  [184,202,203,225,228,230,231,233,326,328,329,331,332,338,371,371,372,373,378,378,405,406],
  [185,202,204,229,232,234,235,237,333,334,336,338,339,345,377,378,379,380,384,385,413,431],
  [188,206,207,236,239,241,242,244,344,345,347,348,350,356,388,389,389,390,395,415,438,451],
  [191,209,211,239,242,244,245,247,351,352,354,356,357,363,395,395,396,397,418,432,453,467],
  [202,217,218,247,250,253,254,256,369,372,373,375,377,382,413,413,414,415,420,441,469,482],
  [205,221,223,252,255,257,258,260,377,378,380,381,383,389,419,421,421,422,445,458,486,499],
  [205,221,223,255,258,260,261,278,384,385,387,389,390,396,427,427,428,447,461,474,503,517],
  [208,225,227,262,265,267,268,285,394,395,397,400,401,407,438,438,440,457,469,482,521,534],
  [212,229,231,266,269,271,273,294,403,404,406,408,410,415,446,447,447,477,494,511,535,552],
  [218,234,236,271,274,276,277,301,414,416,418,419,421,427,457,457,459,488,504,520,550,566],
  [221,238,239,277,282,284,285,310,425,427,428,431,432,438,468,468,486,503,520,537,563,580],
  [225,241,242,282,285,287,288,320,432,434,436,438,439,445,474,476,499,512,524,537,585,598],
  [229,244,246,285,289,291,292,329,443,444,446,448,449,455,485,486,512,528,544,561,598,614],
  [232,248,250,289,293,295,296,337,450,451,453,455,457,463,493,494,526,543,561,578,613,630],
  [238,254,255,297,301,302,304,343,466,467,469,471,473,478,507,507,540,562,582,602,628,648],
  [241,257,258,304,308,309,312,356,476,477,479,481,482,489,518,539,558,577,595,613,651,669],
  [245,261,262,307,312,314,329,362,483,485,486,489,491,496,525,550,568,586,606,624,662,681],
  [248,264,266,312,315,317,335,370,494,495,497,499,501,506,535,564,581,598,615,632,680,697],
  [252,268,269,315,319,321,341,378,501,503,504,506,507,513,542,574,596,617,640,661,691,713],
  [252,268,269,318,323,325,352,388,508,509,511,513,515,521,567,585,610,633,658,682,707,731],
  [256,271,273,326,329,331,360,399,519,521,522,524,525,531,581,608,626,644,662,0,0,0],
  [260,275,277,329,333,335,368,406,526,528,529,531,533,555,593,616,637,658,678,0,0,0],
  [260,275,287,329,334,353,374,416,530,531,533,534,536,565,610,628,648,669,0,0,0,0],
  [263,278,293,336,341,358,382,421,540,541,543,545,548,576,618,640,663,0,0,0,0,0]
  ];

  /* min width, max width, min height, max height - in mm, exactly as printed */
  if (check('wood 70', W70, 376223, 755)) {
    attach(window.NARU_W70, W70, 0.8, 0.6, [800, 2900, 600, 4000]);
  }
  if (check('bamboo 50', B50, 340601, 1026)) {
    attach(window.NARU_B50,  B50, 0.8, 0.3, [800, 3000, 300, 4000]);
    attach(window.NARU_B50W, B50, 0.8, 0.3, [800, 3600, 300, 4000]);
  }
  if (check('bamboo 65', B65, 271605, 755)) {
    attach(window.NARU_B65,  B65, 0.8, 0.6, [800, 2900, 600, 4000]);
    attach(window.NARU_B65W, B65, 0.8, 0.6, [800, 2900, 600, 4000]);
  }
})();
